import LifgateCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['extras', 'liftgate_needed'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { liftgate_needed: lifgateNeeded, extras = [] } = props.selectors.getJourneyFields(
      state,
      props.journeyId,
      fields
    );
    return {
      lifgateNeeded: lifgateNeeded || extras.indexOf('LIFTGATE') >= 0,
    };
  })
);

export default enhance(LifgateCell);
